import { createTypes } from '../../utils/helpers';

const ATTRIBUTE_FETCH: any = createTypes('ATTRIBUTE_FETCH');
const ATTRIBUTE_UPDATE: any = createTypes('ATTRIBUTE_UPDATE');
const ATTRIBUTE_POST: any = createTypes('ATTRIBUTE_POST');
const CLEAR_FOCUSED_ATTRIBUTE = 'CLEAR_FOCUSED_ATTRIBUTE';
const SET_FOCUSED_ATTRIBUTE_MODE = 'SET_FOCUSED_ATTRIBUTE_MODE';

export {
  ATTRIBUTE_FETCH,
  ATTRIBUTE_UPDATE,
  ATTRIBUTE_POST,
  CLEAR_FOCUSED_ATTRIBUTE,
  SET_FOCUSED_ATTRIBUTE_MODE,
};
